import { Link } from "react-router-dom";

const Logo = ({ size = 36, withText = false, linkTo = null, className = "" }) => {
  const inner = (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src="/logo.webp"
        alt="Logo"
        style={{ width: size, height: size }}
        className="object-contain select-none"
        draggable="false"
      />
      {withText && (
        <span className="font-editorial text-2xl tracking-tight">Studio</span>
      )}
    </div>
  );
  if (linkTo) return <Link to={linkTo} data-testid="logo-link">{inner}</Link>;
  return inner;
};

export default Logo;
